import ClubsOverviewPage from '../clubs-overview-page/clubs-overview-page';

const ClubsRegionOverviewPage = ClubsOverviewPage;

export default ClubsRegionOverviewPage;
